// extracted by mini-css-extract-plugin
module.exports = {"form":"NoStripe_form__3aXyv","connectButton":"NoStripe_connectButton__1F9V_","logo":"NoStripe_logo__ONYFL","buttonWrapper":"NoStripe_buttonWrapper__ACIRg"};